import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, 
         DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwQueryHelper, DwFormActionConfig,
         DwQueryParam, DwLookupInfo,
         DwMessagingService, DwOrmDataService, DwOrmDataServiceToken, DwFormActionInterceptor } 
         from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataLookups, AppMetaDataService } from '../../../../meta-data/app-meta-data.service';
import { EquipRentalMetaDataItemNames, RoRequestContextEntity, RequestEntity, EquipRentalMetaDataLookups, EquipRentalMetaDataService,
         CodeValueEquipmentRequestJobContext, RoRequestContextJnEntity } from '../../meta-data/equiprental-meta-data.service';
import { Observable, of } from 'rxjs';
import * as moment_ from 'moment';
const moment = moment_;

@DwComponent({
  name: 'Equip Request UI Util',
  key: 'equipRequestUiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: EquipRentalMetaDataItemNames.Request,
})
@Component({
  selector: 'equip-request-ui-util',
  template: ` 
  `
})
export class EquipRequestUiUtilComponent extends DwSectionBaseComponent implements OnDestroy {
    formApi: DwMetaDataFormApi;

    constructor(
        dwExpressionService: DwExpressionService,
        private messageService:  DwMessagingService,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private dwMetaDataFormStateService: DwMetaDataFormStateService
    ) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }

    setupComponentComplete() {
        this.formApi = this.dwMetaDataFormStateService.state.formApi;
        this.runAfterFormDataLoaded(() => this.setupSubscriptions());
    }
    
    currentCxt: number = undefined;
    lookUp: string = undefined;
    private setupSubscriptions() {
        this.subscriptions.push(this.formApi.getVariableContext().subscribe(vc => {
            const cxt = vc?.JobContext;
            if (this.currentCxt != cxt){
                this.currentCxt = cxt;
            }
        }));

        this.subscriptions.push(this.formApi.getFormDataChanges<RequestEntity>(200).subscribe(req => {
            const lookup = req?.LookUpTarget;
            if (this.lookUp != lookup){
                this.lookUp = lookup;
                if (this.lookUp != undefined && this.lookUp != '')
                    this.handleUpdate();
            }
        }));
    }
    ngOnDestroy(): void { for(const subscription of this.subscriptions) subscription.unsubscribe(); } 

    updateData(jobName: string, jobNumber: string, target: string, addr: string){
        this.formApi.patchFormData({
            JobName: jobName,
            JobNumber: jobNumber,
            LookUpTarget: target,
            JobSiteAddress: addr
        });
    }
    handleUpdate() {
        if (this.formApi == undefined) return;
        if (this.currentCxt == undefined || this.lookUp == undefined) return;
        const md = new EquipRentalMetaDataService();
        const qh = new DwQueryHelper();
        const isJn = this.currentCxt == CodeValueEquipmentRequestJobContext.JobNumber;
        const isPo = this.currentCxt == CodeValueEquipmentRequestJobContext.PONumber;
        const query = isJn ? md.RoRequestContextJn.CreateQuery() : isPo ? md.RoRequestContextPo.CreateQuery() :
                             md.RoRequestContextWjid.CreateQuery()
        const suffix = isJn ? "Jn" : isPo ? "Po" : "Wjid";
        const tbl = `RoRequestContext${suffix}.`;
        query.AddFilterAnd(qh.filters.Equal(tbl + 'CodeValueId', this.currentCxt));
        query.AddFilterAnd(qh.filters.Equal(tbl + 'Target', this.lookUp));
        this.dataService.executeQuerySingle<RoRequestContextEntity>(query)
            .subscribe(data => {
                if (data != undefined)
                    this.updateData(data.JobName, data.Target, this.lookUp, (data as any).Address);
                if (isJn){
                    const asJn : RoRequestContextJnEntity = data;
                    this.formApi.patchVariableContext({ IsOverhead: asJn.OH });
                }
            });
    }
}
export interface EquipRequestVariableContext {
    JobContext?: number;
    IsOverhead?: boolean;
}
